import { render, staticRenderFns } from "./livetable.vue?vue&type=template&id=db537e9e"
import script from "./livetable.vue?vue&type=script&lang=js"
export * from "./livetable.vue?vue&type=script&lang=js"
import style0 from "./livetable.vue?vue&type=style&index=0&id=db537e9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports